export const ITEM_PAGE_ARR = ['/product/BLEU', '/product/VERT', '/product/ROUGE', '/product/ROSE'];
